<template>
  <div class="bravado-avatar">
    <div class="bravado-avatar__image">
      <img height="150" width="150" loading="lazy" :src="item.image" :alt="item.name" />
    </div>

    <div class="bravado-avatar__name">
      {{ item.name }}
    </div>

    <div class="bravado-avatar__title">
      {{ item.title }}
    </div>
  </div>
</template>

<script lang="ts">
import type { PropOptions } from 'vue';
import Vue from 'vue';

export type BravadoAvatarItem = {
  image: string;
  name: string;
  title: string;
};

export default Vue.extend({
  name: 'BravadoAvatar',
  props: {
    item: {
      type: Object,
      required: true,
    } as PropOptions<BravadoAvatarItem>,
  },
});
</script>

<style lang="scss" scoped>
.bravado-avatar {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__image {
    border-radius: 25px;
    overflow: hidden;
    width: 117px;
    height: 117px;
    margin-bottom: 14px;

    img {
      width: 100%;
      height: auto;
    }
  }

  &__name {
    font-weight: 600;
    font-size: 17px;
    line-height: 26px;
    text-align: center;
    color: var(--white);
    margin-bottom: 1px;
  }

  &__title {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: var(--gray-50);
  }
}

@media (min-width: 768px) {
  .bravado-avatar {
    &__image {
      width: 150px;
      height: 150px;
      margin-bottom: 16px;
    }

    &__name {
      font-size: 28px;
      line-height: 36px;
      margin-bottom: 3px;
      letter-spacing: -0.75px;
    }

    &__title {
      font-size: 15px;
    }
  }
}
</style>
